<template>
    <el-menu :collapse="isCollapse" router>
        <el-menu-item index="/flow/shop/day" v-if="validPriv('004001')">
            <template #title>流量总览</template>
        </el-menu-item>
        <el-menu-item index="/flow/shop/summary" v-if="validPriv('004001')">
            <template #title>流量概况</template>
        </el-menu-item>
        <el-menu-item index="/flow/shop/trend" v-if="validPriv('004001')">
            <template #title>流量走势</template>
        </el-menu-item>
        <el-menu-item index="/flow/shop/area-analysis" v-if="validPriv('004001') && false">
            <template #title>大区分析</template>
        </el-menu-item>
        <el-menu-item index="/flow/shop/type" v-if="validPriv('004001')">
            <template #title>业态总览</template>
        </el-menu-item>
        <el-menu-item index="/flow/shop/holiday" v-if="validPriv('004001')">
            <template #title>节假日分析</template>
        </el-menu-item>
        <el-menu-item index="/flow/shop/time-flow" v-if="validPriv('004001')">
            <template #title>时段流量</template>
        </el-menu-item>
        <el-menu-item index="/flow/shop/flow-distribute" v-if="validPriv('004001')">
            <template #title>流量分布</template>
        </el-menu-item>
        <el-menu-item index="/flow/shop/rank-analysis" v-if="validPriv('004001')">
            <template #title>排名分析</template>
        </el-menu-item>
        <el-menu-item index="/flow/shop/compare-analysis" v-if="validPriv('004001')">
            <template #title>对比分析</template>
        </el-menu-item>
        <el-menu-item index="/flow/shop/flow-compare" v-if="validPriv('004001')">
            <template #title>流量对比</template>
        </el-menu-item>

        <!--        <el-menu-item index="/flow/shop/day" v-if="validPriv('004001')">-->
        <!--            <template #title>流量分析</template>-->
        <!--        </el-menu-item>-->
        <!--        <el-menu-item index="/flow/shop/day" v-if="validPriv('004001')">-->
        <!--            <template #title>业态分析</template>-->
        <!--        </el-menu-item>-->
        <el-menu-item index="/flow/shop/door" v-if="validPriv('004001')">
            <template #title>出入口明细</template>
        </el-menu-item>
        <!--        <el-menu-item index="/flow/statistic" v-if="validPriv('004002')">-->
        <!--            <template #title>经营品类分析</template>-->
        <!--        </el-menu-item>-->
        <el-menu-item index="/flow/shop/entity" v-if="validPriv('004001')">
            <template #title>实时数据明细</template>
        </el-menu-item>
    </el-menu>
</template>
<script>
import auth from "../../../scripts/auth";
export default {
    methods: {
        validPriv(code) {
            return auth.validPrivCode(code);
        },
    },
};
</script>
